/**
 * Formata uma coordenada geográfica adicionando o sinal e a direção.
 * @param value Valor numérico da coordenada (latitude ou longitude)
 * @param direction Direção cardeal (N, S, E, W)
 * @returns String formatada com sinal, valor absoluto com 4 casas decimais e direção
 */
export const getFormattedCoordinate = (value: number, direction: string): string => {
  const sign = direction === "S" || direction === "W" ? "-" : "+";
  return `${sign}${Math.abs(value).toFixed(4)}${direction}`;
};